import { COUNTRIES } from "@/data/countries";

export const QUESTIONS_PER_DAY = 10;

export function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

// Build today's session of 10 questions deterministically per date so refresh keeps state stable.
// Returns array of { country, capital, options: [4 capitals shuffled] }
export function buildDailySession(dataset = COUNTRIES) {
  const picks = shuffle(dataset).slice(0, QUESTIONS_PER_DAY);
  const allCapitals = dataset.map((d) => d.capital);

  return picks.map((item) => {
    const distractorPool = allCapitals.filter((c) => c !== item.capital);
    const distractors = shuffle(distractorPool).slice(0, 3);
    const options = shuffle([item.capital, ...distractors]);
    return {
      country: item.country,
      capital: item.capital,
      options,
    };
  });
}

export function todayKey(date = new Date()) {
  // Local date in YYYY-MM-DD format
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function msUntilTomorrow(date = new Date()) {
  const next = new Date(date);
  next.setHours(24, 0, 0, 0);
  return next.getTime() - date.getTime();
}

export function formatCountdown(ms) {
  if (ms < 0) ms = 0;
  const totalSec = Math.floor(ms / 1000);
  const h = String(Math.floor(totalSec / 3600)).padStart(2, "0");
  const m = String(Math.floor((totalSec % 3600) / 60)).padStart(2, "0");
  const s = String(totalSec % 60).padStart(2, "0");
  return `${h}:${m}:${s}`;
}
